import { PureComponent } from 'preact-compat'
import { ContentType } from '@insided/shared/utils/contentType'
import { setModerationLabel, unsetModerationLabel } from '@insided/shared/services/topicService'
import Button from '@insided/control/uikit/Button'
import classNames from 'classnames'
import { ModerationLabel } from '../interfaces'

interface ModerationLabelsProps {
  onModerationLabelChanged: (newModerationLabel: ModerationLabel | null) => void
  setIsLoading: (isLoading: boolean) => void
  selectedModerationLabel: ModerationLabel | null
  moderationLabels: ModerationLabel[]
  contentType: ContentType
  privateId: number
}

class ModerationLabels extends PureComponent<ModerationLabelsProps> {
  constructor (props: ModerationLabelsProps) {
    super(props)
    this.onChangeModerationLabel = this.onChangeModerationLabel.bind(this)
  }

  isModerationLabelSelected (moderationLabel: ModerationLabel) {
    return moderationLabel.id === this.props.selectedModerationLabel?.id
  }

  async onChangeModerationLabel (moderationLabel: ModerationLabel) {
    const { contentType, privateId, onModerationLabelChanged, setIsLoading } = this.props
    setIsLoading(true)
    try {
      if (this.isModerationLabelSelected(moderationLabel)) {
        await unsetModerationLabel(contentType, [privateId])
        onModerationLabelChanged(null)
      } else {
        await setModerationLabel(contentType, [privateId], Number(moderationLabel.id))
        onModerationLabelChanged(moderationLabel)
      }
    } finally {
      setIsLoading(false)
    }
  }

  render () {
    const { moderationLabels } = this.props
    return (
      <div className='topic-info__details-item full-width'>
        <label>Labels</label>
        <div className='moderation-label-container'>
          {moderationLabels.map((moderationLabel: ModerationLabel) => {
            const isSelected = this.isModerationLabelSelected(moderationLabel)
            return (
              <Button
                key={moderationLabel.id}
                title={moderationLabel.title}
                className={classNames('moderation-label', { selected: isSelected })}
                onClick={async () => await this.onChangeModerationLabel(moderationLabel)}
              />
            )
            }
          )}
        </div>
      </div>
    )
  }
}

export default ModerationLabels
